import { useDispatch, useSelector } from 'react-redux'
import { a11ySelector, setA11yColorScheme } from '../../../../redux/slices/a11y'
import BwIcon from './Icons/BwIcon'
import ColoredIcon from './Icons/ColoredIcon'

const ColorSwitcher = () => {
  const { a11yColorScheme } = useSelector(a11ySelector)
  const dispatch = useDispatch()

  const changeScheme = (e) => {
    const a11yColorScheme = e.target.value
    dispatch(setA11yColorScheme(a11yColorScheme))
  }

  return (
    <div className="color_switcher">
      <span className="switcher_title">Відображення кольору</span>

      <form className="switch_component">
        <input
          checked={a11yColorScheme === ''}
          value=""
          onChange={changeScheme}
          type="radio"
          id="scheme_colored"
          name="switch_scheme"
        />
        <label htmlFor="scheme_colored">
          <ColoredIcon />
          <span>Кольорове</span>
        </label>

        <input
          checked={a11yColorScheme === 'a11y_colorblind'}
          value="a11y_colorblind" // = className for .App
          onChange={changeScheme}
          type="radio"
          id="scheme_colorblind"
          name="switch_scheme"
        />
        <label htmlFor="scheme_colorblind">
          <BwIcon />
          <span>Чорно-біле</span>
        </label>
      </form>
    </div>
  )
}

export default ColorSwitcher
